import { API_URL } from "env";

function getCustomerID(): number | null {
    const userData = localStorage.getItem('user');
    if (userData) {
        const user = JSON.parse(userData);
        return user.id || null;
    }
    return null;
}

async function getListCustomerInvoices(page: number, limit: number) {
    try {
        const customerID = getCustomerID();
        if (customerID === null) {
            throw new Error('Customer ID not found');
        }
        const response = await fetch(`${API_URL}/api/v1/fe/customer_invoices?sort[]=created_at,desc&customer_id=${customerID}`, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem('token') || ''}`,
            },
        });

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();
        return data;
    } catch (error) {
        console.error('Failed to fetch customer invoices:', error);
        throw error;
    }
}
interface InvoiceData {
    name?: string;
    name_company?: string;
    tax_code?: string;
    address?: string;
    province?: string;
    district?: string;
    ward?: string;
}
async function addCustomerInvoice(invoiceData: InvoiceData) {
    try {
        const customerID = getCustomerID();
        if (customerID === null) {
            throw new Error('Customer ID not found');
        }
        const body = new FormData();
        if (invoiceData.name) body.append('name', invoiceData.name);
        if (invoiceData.name_company) body.append('name_company', invoiceData.name_company);
        if (invoiceData.tax_code) body.append('tax_code', invoiceData.tax_code);
        if (invoiceData.address) body.append('address', invoiceData.address);
        if (invoiceData.province) body.append('province', invoiceData.province);
        if (invoiceData.district) body.append('district', invoiceData.district);
        if (invoiceData.ward) body.append('ward', invoiceData.ward);
        const response = await fetch(`${API_URL}/api/v1/fe/customer_invoice`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem('token') || ''}`,
            },
            body: body,
        });

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();
        return data;
    } catch (error) {
        console.error('Failed to add customer invoice:', error);
        throw error;
    }
}

async function updateCustomerInvoice(invoiceID: number, invoiceData: any) {
    try {
        const customerID = getCustomerID();
        if (customerID === null) {
            throw new Error('Customer ID not found');
        }
        const response = await fetch(`${API_URL}/api/v1/fe/customer_invoice/${invoiceID}`, {
            method: 'PUT',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem('token') || ''}`,
            },
            body: JSON.stringify(invoiceData),
        });

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();
        return data;
    } catch (error) {
        console.error('Failed to update customer invoice:', error);
        throw error;
    }
}

async function deleteCustomerInvoice(invoiceID: number) {
    try {
        const customerID = getCustomerID();
        if (customerID === null) {
            throw new Error('Customer ID not found');
        }
        const response = await fetch(`${API_URL}/api/v1/fe/customer_invoice/${invoiceID}`, {
            method: 'DELETE',
            headers: {
                'Accept': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem('token') || ''}`,
            },
        });

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();
        return data;
    } catch (error) {
        console.error('Failed to delete customer invoice:', error);
        throw error;
    }
}

export {
    getListCustomerInvoices,
    addCustomerInvoice,
    updateCustomerInvoice,
    deleteCustomerInvoice,
}